<template>
  <el-dialog 
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      class="no-border-dialog"
      >
      <div v-if="budgetCheckPassed" class="color-success">
        <i class="el-icon-success "></i>{{budgetCheckPassed}}
      </div>
      <div v-if="budgetCheckFailed" class="color-red">
      <i class="el-icon-error"></i>{{budgetCheckFailed}}
      </div>
      <span slot="footer">
        <el-button  size="small" class="btn-red" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
</template>
<script>
  export default {
    name:'item-order-budget-dialog',
    props: {
      noEnoughAmount:{
        type: Number,
        default:0
      },
      budgetCheckPassed:{
        type: String,
        default:''
      },
      budgetCheckFailed:{
        type: String,
        default:''
      }
    },
    data() {
      return {
        dialogVisible: false,
      }
    },
    computed:{
      title(){
        if(this.budgetCheckPassed) return '预算充足'
        if(this.budgetCheckFailed) return '预算不足'
        return ''
      }
    },
    methods: {
      open(){
        this.dialogVisible = true
      }
    },
  }
</script>
<style lang="scss" scoped>
.color-success{
  i{
    color:$base-green;
    font-size: 20px;
    line-height: 18px;
    margin-right: 5px;
  }
}
.color-red{
  color:$base-red;
  i{
    font-size: 20px;
    line-height: 18px;
    margin-right: 5px;
  }
}
</style>
